import { createDefaultInstrumentPatch, normalizeInstrumentPatch } from './patchSchema';
import { defaultAfmOperators } from './afmSchema';

const configs = [
  ['Crystal Tines', 'Keys', 0, 2.4, [1, 14, 1, 3, 1, 7], 0.08, 0.005, 1.4, 0.35],
  ['Deep FM Sub', 'Bass', 1, 1.6, [0.5, 1, 1, 2, 1, 1], 0.3, 0.003, 0.4, 0.55],
  ['Prism Bells', 'Bell', 4, 3.8, [1, 2.76, 5.4, 2, 3.14, 7.1], 0.12, 0.002, 3.5, 0],
  ['Silk FM Pad', 'Pad', 6, 1.1, [1, 1, 2, 1, 3, 2], 0.05, 0.9, 2.5, 0.65],
  ['Voltage Brass', 'Lead', 2, 2.7, [1, 1, 2, 3, 4, 5], 0.22, 0.025, 0.6, 0.6],
  ['Six Sine Organ', 'Keys', 5, 0, [0.5, 1, 2, 3, 4, 6], 0, 0.004, 0.1, 1]
];
export const ADVANCED_FM_PRESETS = configs.map(([name, category, algorithm, index, ratios, feedback, attack, decay, sustain]) => {
  const base = createDefaultInstrumentPatch();
  const operators = defaultAfmOperators().map((op, i) => ({ ...op, ratio: ratios[i],
    level: algorithm === 5 ? [0.9,0.8,0.6,0.35,0.25,0.16][i] : (i % 2 ? 0.48 : 0.78),
    feedback: i === 5 ? feedback : 0, attack, decay: decay * (i % 2 ? 0.6 : 1),
    sustain: i % 2 ? sustain * 0.45 : sustain, release: category === 'Pad' ? 1.5 : 0.35 }));
  return normalizeInstrumentPatch({ ...base,
    id: `afm-${name.toLowerCase().replace(/ /g,'-')}`, name, category, tags: ['AFM', 'Six Operator', 'Rust'],
    macros: Object.fromEntries(Object.keys(base.macros).map(key => [key, key === 'Space' ? 0.2 : 0])),
    layers: base.layers.map((layer,i) => ({ ...layer, enabled: i === 0, engine: i === 0 ? 'afm' : layer.engine,
      name: i === 0 ? 'Six Operator Core' : layer.name, level: 0.8, index, afm: { algorithm, operators } })),
    ampEnvelope: { attack: 0.003, decay: 0.1, sustain: 1, release: category === 'Pad' ? 1.8 : 0.45, velocity: 0.5 },
    filter: { ...base.filter, enabled: false }, filterEnvelope: { ...base.filterEnvelope, amount: 0 },
    lfo: { ...base.lfo, enabled: false }, lfo2: { ...base.lfo2, enabled: false },
    effects: { ...base.effects, distortion: { ...base.effects.distortion, enabled: false },
      chorus: { ...base.effects.chorus, enabled: category === 'Pad', mix: 0.15 },
      delay: { ...base.effects.delay, enabled: false }, reverb: { ...base.effects.reverb, mix: 0.12 } },
    performance: { ...base.performance, master: 0.65, glide: 0 }
  });
});
